import { GET_USER_REQUEST, GET_USER_SUCCESS, GET_USER_FAILURE,
    FILTER_USERS_BY_GROUP_LABEL_SUCCESS, FILTER_USERS_BY_GROUP_LABEL_FAILURE
} from '../action/user';

const initialState = {
    loading: false,
    user: null,
    error: null,
    filteredUsers: [],
};

const userReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_USER_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case GET_USER_SUCCESS:
            return {
                ...state,
                loading: false,
                user: action.payload
            };
        case GET_USER_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        case FILTER_USERS_BY_GROUP_LABEL_SUCCESS:
            return {
                ...state,
                loading: false,
                filteredUsers: action.payload,
            };
        case 'FILTER_USERS_BY_GROUP':
            return {
                ...state,
                usersByGroups: action.payload,
            };
        case FILTER_USERS_BY_GROUP_LABEL_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default userReducer;
